var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgActivegroup = function SvgActivegroup(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#148DFD",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M9.178 7.321a1.667 1.667 0 1 1-2.357 2.357 1.667 1.667 0 0 1 2.357-2.357M12.836 3.321a1.667 1.667 0 1 1-2.357 2.357 1.667 1.667 0 0 1 2.357-2.357M12 8.167c1.022 0 2 .355 2.667.888M5.521 3.321a1.667 1.667 0 1 1-2.357 2.357 1.667 1.667 0 0 1 2.357-2.357M1.333 9.055C2 8.522 2.978 8.167 4 8.167M11.06 13.167c-.776-.601-1.892-1-3.06-1-1.168 0-2.284.399-3.06 1"
  })));
};
export { SvgActivegroup as ReactComponent };
export default "data:image/svg+xml;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZTM0ZDQyZDkxNTg4YWIwNDY2MjRhNTI1ODRmY2ZlYTguc3ZnIjs=";